import { useMemo } from 'react';
import { useRealtimeStore } from '../../store/realtimeStore';
import { useTargetStore } from '../../store/targetStore';
import { useCcStore } from '../../store/ccStore';

const ONLINE_MS = 5 * 60 * 1000;
const ACTIVE_SOS = ['TRIGGERED', 'ACKNOWLEDGED', 'RESPONDING'];

// Compact KPI ticker for the app header / ops-wall.
export default function KpiTicker() {
  const { locations, sosEvents } = useRealtimeStore();
  const { targets } = useTargetStore();
  const activeExecutions = useCcStore((s) => s.activeExecutions);

  const stats = useMemo(() => {
    const now = Date.now();
    let online = 0;
    for (const loc of locations.values()) {
      if (now - new Date(loc.serverTime).getTime() < ONLINE_MS) online++;
    }
    const activeTargets = targets.filter((t) => ['ACTIVE', 'ASSIGNED', 'EXECUTING'].includes(t.status)).length;
    const executing = Math.max(
      Object.keys(activeExecutions).length,
      targets.filter((t) => t.status === 'EXECUTING').length
    );
    const openSos = sosEvents.filter((e) => ACTIVE_SOS.includes(e.status)).length;
    return { online, activeTargets, executing, openSos };
  }, [locations, targets, activeExecutions, sosEvents]);

  const items: { label: string; value: number; tone: string }[] = [
    { label: 'PLATOONS ONLINE', value: stats.online, tone: 'text-command-accent' },
    { label: 'ACTIVE TARGETS', value: stats.activeTargets, tone: 'text-amber-400' },
    { label: 'EXECUTIONS', value: stats.executing, tone: 'text-orange-400' },
    { label: 'OPEN SOS', value: stats.openSos, tone: stats.openSos ? 'text-red-400' : 'text-gray-400' },
  ];

  return (
    <div className="flex items-center gap-4 px-3 py-1 rounded-lg bg-command-panel border border-command-border">
      {items.map((it) => (
        <div key={it.label} className="flex items-center gap-1.5 whitespace-nowrap">
          <span className={`font-display font-bold text-sm ${it.tone}`}>{it.value}</span>
          <span className="text-[9px] text-gray-500 font-tactical tracking-wide">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
